// extracted by mini-css-extract-plugin
export var attribution = "_ay-4";
export var authorName = "_ay-5";
export var quote = "_ay-3";
export var testimonial = "_ay-2";
export var trustedBy = "_ay-0";
export var trustedByLabel = "_ay-1";